// @ts-nocheck

import classNames from 'classnames';
import * as React from 'react';
import type { TitleProps } from '../../types/titleTypes';
import Tooltip from './Tooltip';

class Title extends React.PureComponent<TitleProps> {
  renderLabel = () => {
    const props = this.props;

    if (props.hoverableTooltip) {
      return (
        <label className={classNames('h_mend-5 h_mb-0', props.labelClassName)}>
          <Tooltip body={props.hoverableTooltip} infoIconClassName={props.infoIconClassName}>
            {props.label}
          </Tooltip>
        </label>
      );
    }

    return (
      <div>
        <label className={classNames('h_mend-5 h_mb-0', props.labelClassName)}>{props.label}</label>
        {props.tooltip && <Tooltip body={props.tooltip} infoIconClassName={props.infoIconClassName} />}
      </div>
    );
  };

  render() {
    const props = this.props;

    if (!props.label) {
      return null;
    }

    return (
      <div className="h_mb-5" data-testid="title">
        {this.renderLabel()}
        {props.description && (
          <div className={classNames('label__description', props.descriptionClassName)} data-testid="description">
            {props.description}
          </div>
        )}
      </div>
    );
  }
}

export default Title;
